import Swal from 'sweetalert2';

/**
 * Configuração do SweetAlert2 com suporte a modo escuro
 */

// Função para detectar se o modo escuro está ativo
function isDarkMode() {
  return document.documentElement.classList.contains('dark');
}

// Configuração padrão baseada no tema atual
function getThemeConfig() {
  const darkMode = isDarkMode();
  
  return {
    background: darkMode ? '#101a34' : '#ffffff',
    color: darkMode ? '#e5e7eb' : '#1f2937',
    confirmButtonColor: '#facc15',
    cancelButtonColor: darkMode ? '#6b7280' : '#9ca3af',
    customClass: {
      popup: darkMode ? 'dark-swal-popup' : 'light-swal-popup',
      title: darkMode ? 'dark-swal-title' : 'light-swal-title',
      content: darkMode ? 'dark-swal-content' : 'light-swal-content',
      confirmButton: 'swal-confirm-button',
      cancelButton: 'swal-cancel-button'
    }
  };
}

// Wrapper para Swal.fire com configuração automática de tema
export const SwalWithTheme = {
  fire: (options) => {
    const themeConfig = getThemeConfig();
    const mergedOptions = {
      heightAuto: false,
      returnFocus: false,
      target: document.body,
      ...themeConfig,
      ...options
    };
    return Swal.fire(mergedOptions);
  },
  
  success: (title, text) => {
    return SwalWithTheme.fire({
      title,
      text,
      icon: 'success'
    });
  },
  
  error: (title, text) => {
    return SwalWithTheme.fire({
      title,
      text,
      icon: 'error'
    });
  },
  
  warning: (title, text) => {
    return SwalWithTheme.fire({
      title,
      text,
      icon: 'warning'
    });
  },
  
  confirm: (title, text, confirmText = 'Sim', cancelText = 'Cancelar') => {
    return SwalWithTheme.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText
    });
  },

  showLoading: () => {
    Swal.showLoading();
  },

  close: () => {
    Swal.close();
  }
};

// Adicionar estilos CSS personalizados para o SweetAlert2
const STYLE_ELEMENT_ID = 'flamex-sweetalert-theme';

if (!document.getElementById(STYLE_ELEMENT_ID)) {
  const style = document.createElement('style');
  style.id = STYLE_ELEMENT_ID;
  style.textContent = `
  .swal2-container {
    z-index: 2400 !important;
    pointer-events: auto !important;
  }

  .swal2-popup,
  .swal2-actions,
  .swal2-confirm,
  .swal2-cancel {
    pointer-events: auto !important;
  }

  .dark-swal-popup {
    background-color: #101a34 !important;
    border: 1px solid #253257 !important;
  }
  
  .dark-swal-title {
    color: #e5e7eb !important;
  }
  
  .dark-swal-content {
    color: #d1d5db !important;
  }
  
  .light-swal-popup {
    background-color: #ffffff !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .light-swal-title {
    color: #374151 !important;
  }
  
  .light-swal-content {
    color: #6b7280 !important;
  }
  
  .swal-confirm-button {
    background-color: #facc15 !important;
    color: #111827 !important;
    border: none !important;
    font-weight: 600 !important;
  }
  
  .swal-confirm-button:hover {
    background-color: #eab308 !important;
  }
  
  .swal-cancel-button {
    background-color: #6b7280 !important;
    color: #ffffff !important;
    border: none !important;
  }
  
  .swal-cancel-button:hover {
    background-color: #4b5563 !important;
  }
`;
  document.head.appendChild(style);
}

export default SwalWithTheme;
